/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from 'react-redux'
import React from 'react'
import { withRouter } from 'react-router'

import * as act from '../actions/teams'

import './TeamEditContainer.css'
import TeamEditor from '../components/TeamEditor'
import ContainerWithMenu from './ContainerWithMenu'
import Modal from '../../../components/Modal'
import * as staff from '../actions/staff'
import {webApi} from '../../../lib/WebApi'

import TRCInput from '../../../trace/TRCInput'
import TRCButton from '../../../trace/TRCButton'
import { formatShortName, formatFullName } from '../../../trace/formatters'
import { pageTitle } from 'trux'
import LoadingMessage from '../../../components/LoadingMessage'


export class TeamEdit extends ContainerWithMenu {

    constructor(props) {
        super(props, 'TeamEdit')

        this.state = {
            editorState: {},
            errors: [],
            isDeleteModalOpened: false,
            roles: {}
        }

        this.onBackToTeam = this.onBackToTeam.bind(this)
        this.onSaveAll = this.onSaveAll.bind(this)
        this.onDeleteTeam = this.onDeleteTeam.bind(this)
        this.onEditorUpdate = this.onEditorUpdate.bind(this)
        this.onRequestDeleteModalClose = this.onRequestDeleteModalClose.bind(this)
        this.doDeleteTeam = this.doDeleteTeam.bind(this)
        this.onRoleChanged = this.onRoleChanged.bind(this)
    }

    componentDidMount() {
        pageTitle(this.props.title, 'Settings - Team Edit')

        if (this.props.match.params.user && this.props.match.params.token) {
            this.props.fromIOS()
            var that = this
            this.props.loginByCode(this.props.match.params.user, this.props.match.params.token, () => {
                that.props.loadTeams(this.props.divisionId)
            })
        } else {
            this.props.loadTeams(this.props.divisionId)
        }
        console.log('MemberEditTeam.componentDidMount')
    }

    shortenName(fullName) {
        const parts = fullName.split(' ')
        if(parts.length > 1) {
            return `${parts[0]} ${parts[1].charAt(0)}`
        }
        return parts[0]
    }

    /*
    componentWillReceiveProps(nextProps) {
        if(nextProps.divisionId !== this.props.divisionId) {
            this.props.history.replace(`/division/${nextProps.divisionId}/teams`)
        }

        if(!this.props.team && nextProps.team && nextProps.team.team_id) {
            this.props.loadTeamMembers(nextProps.team.team_id)
        }
    }
    */

    /*
    componentWillMount() {
        if(!this.props.team) {
            this.props.loadTeams(this.props.divisionId)
        } else {
            if(this.props.team.team_id) {
                this.props.loadTeamMembers(this.props.team.team_id)
            }
        }
        this.props.loadMembers(this.props.divisionId)
    }
    */

    isFromIOS() {
        return this.props.via === 'iosapp'
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="TeamPage modal-container">
                    <LoadingMessage />
                </div>
            )
        }


        return (
            <div className="TeamPage modal-container">
                <form id="team_edit" onSubmit={this.onSaveAll}>
                    <TeamEditor
                        team={this.props.team}
                        members={this.props.members}
                        onChange={this.onEditorUpdate}
                        onMemberRoleChanged={this.onRoleChanged}
                        errors={this.state.errors}
                    />
                    <div className="trc-grid bottom-buttons">
                        <div className="col ml-push-6 m-ff12 ml-f6">
                            <TRCInput full type="submit" value="Update" />
                        </div>
                    </div>
                </form>
                <div className="delete-buttons">
                    <TRCButton
                        ghost
                        whoops
                        onClick={this.onDeleteTeam}>
                        Permanently Delete This Team
                    </TRCButton>
                </div>
                <Modal
                    title="Delete team?"
                    open={this.state.isDeleteModalOpened}
                    onRequestClose={this.onRequestDeleteModalClose}
                    hideCloseBtn={true}>

                    <span className="delete-team">
                        {`Are you sure you want to delete team "${this.props.team.title}"?`}
                    </span>
                    <div className="trc-grid buttons modal-delete-buttons">
                        <div className="col m-f6">
                            <TRCButton
                                full
                                whoops
                                onClick={this.doDeleteTeam}>
                                Delete
                            </TRCButton>
                        </div>
                        <div className="col m-f6">
                            <TRCButton
                                full
                                secondary
                                onClick={this.onRequestDeleteModalClose}>
                                Cancel
                            </TRCButton>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    onLinkWithTeamLogin(link) {
        webApi.login(this.props.team.team_id, this.props.team.access_password)
            .then(() => {
                window.location.href = link
            }, () => {
                window.location.href = link
            })
    }

    onBackToTeam(e) {
        e.preventDefault()
        this.props.history.goBack()
    }

    onSaveAll(e) {
        console.log('About to submit team data: ' + JSON.stringify(this.state.editorState))

        const data = this.state.editorState
        let errors = []

        if(!data.title || data.title.trim().length === 0) {
            errors.push({ field: 'title', error: 'Title can\'t be empty' })
        }

        if(!data.abbr || data.abbr.trim().length > 6 || data.abbr.trim().length < 2) {
            errors.push({ field: 'abbr', error: 'Abbreviation (3-6 letters)'})
        }

        if(!data.players_birth_year || parseInt(data.players_birth_year, 10) < 1970) {
            errors.push({ field: 'players_birth_year', error: 'Birth Year > 1970' })
        }

        if(!data.players_gender || data.players_gender === '--') {
            errors.push({ field: 'players_gender', error: 'Choose: Male or Female'})
        }

        this.setState({errors: errors})
        e.preventDefault()

        if(errors.length === 0) {
            this.doSaveChanges()
        }
    }

    doSaveChanges() {
        var editState = Object.assign({}, this.state.editorState)
        if (editState.title) {
            editState.title = editState.title.trim()
        }
        if (editState.abbr) {
            editState.abbr = editState.abbr.trim()
        }
        if (editState.players_birth_year) {
            editState.players_birth_year = parseInt(editState.players_birth_year, 10)
        }


        if(this.props.changeTeam) {
            this.props.changeTeam(this.props.teamId, editState, this.props.divisionId)
        }
        /*
        const roles = this.getRolesList()
        let update = []
        for (let role of roles) {
            if (role.role) {
                let teamPlayerId = role.teamUser ? role.teamUser.team_player_id : null
                update.push({
                    team_id: this.props.teamId,
                    user_id: role.id,
                    is_player: false,
                    is_coach: role.role === 'coach',
                    is_videographer: role.role === 'manager',
                    team_player_id: teamPlayerId
                })
            }
        }
        this.props.changeRoles(this.props.divisionId, update)
        */

        this.props.history.goBack()
    }

    onDeleteTeam(e) {
        e.preventDefault()
        this.setState({isDeleteModalOpened: true})
    }

    onEditorUpdate(newState, field) {
        console.log('New editor state: ' + JSON.stringify(newState))
        const errors = this.state.errors.filter((item) => item.field !== field)
        this.setState({editorState: newState, errors: errors})
    }

    onRoleChanged(userId, role) {
        console.log('onRoleChanged', userId, role)
        //this.setState({roles: Object.assign({}, this.state.roles, newRoles)})

        let uid = parseInt(userId, 10)
        let member = this.props.members.find(m => m.user_id === uid) 
        member.team_id = this.props.teamId
        console.log('TeamEditContainer.onRoleChanged', member)

        switch(role) {
        case 'coach':
            member.is_coach = '1'
            member.is_videographer = '0'
            break
        case 'manager':
            member.is_coach = '0'
            member.is_videographer = '1'
            break
        case 'reset':
        default:
            member.is_coach = '0'
            member.is_videographer = '0'
        }

        if (role !== 'reset') {
            this.props.changeRole(member, this.props.teamId, this.props.divisionId)
        } else {
            this.props.resetTeamMember(member, this.props.teamId, this.props.divisionId)
        }
    }

    onRequestDeleteModalClose(e) {
        if(e) e.preventDefault()
        this.setState({isDeleteModalOpened: false})
    }

    doDeleteTeam(e) {
        if(e) e.preventDefault()
        this.setState({isDeleteModalOpened: false})
        this.props.deleteTeam(this.props.team.division_team_id, this.props.team.team_id, this.props.divisionId)
        this.props.history.goBack()
        setTimeout(() => {
            window.location.reload()
        }, 100)
    }
}

const mapStateToProps = (state, props) => {
    /*
    let via = state.via
    let teams = []
    const divisionId = parseInt(props.match.params.division_id, 10)
    const teamId = parseInt(props.match.params.team_id, 10)
    let team = null 
    let users = state.division_staff.value.staff
    let teamUsers = state.team_staff.value.staff

    return {
        via,
        teams,
        divisionId,
        teamId,
        team,
        users,
        teamUsers,
        title: 'Edit Team'
    }
    */

    const rev = state.rev
    const via = state.via
    const divisionId = parseInt(props.match.params.division_id, 10)
    const teamName = props.match.params.teamName
    const teamId = parseInt(props.match.params.team_id, 10)
    const title = 'Edit Team'
    let loading = true
    let team = { team_id: 0, name: '', title: '' }
    let members = []

    // Load Team
    if (state.divisions.value) {
        let division = state.divisions.value.find(d => d.division_id === divisionId)
        if (division) {
            team = division.teams.find(tm => tm.team_id === teamId)
        }
    }

    // Load members
    if (state.division_staff.complete && state.team_staff.complete && state.team_staff.value && parseInt(state.team_staff.value.team_id, 10) === teamId) {
        for (let dm of state.division_staff.value.staff) {
            let member = Object.assign({}, dm)
            let tm = state.team_staff.value.staff.find(m => m.user_id === dm.user_id)
            if (tm) {
                member.team_player_id = tm.team_player_id
                member.team_id = tm.team_id
                member.is_active = tm.is_active === '1'
                member.is_player = tm.is_player === '1'
                member.is_videographer = tm.is_videographer === '1'
                member.is_coach = tm.is_coach === '1'
                member.user = tm.user
                member.loading = tm.loading
                member.error = tm.error
            }
            member.id = 'team-role-editor-memeber'+dm.user_id
            member.short_name = formatShortName(dm)
            member.full_name = formatFullName(dm)
            member.link = `#/${teamName}/settings/division/${divisionId}/staff/${dm.user_id}/edit`
            members.push(member)
        }
    }

    loading = team.team_id < 1 || !state.division_staff.complete || !state.team_staff.complete


    return {
        via,
        divisionId,
        teamId,
        loading: loading,
        title,
        team,
        members,
        rev
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fromIOS: () => {
            dispatch({
                type: 'COMMON_SET',
                key: 'via',
                value: 'iosapp'
            })
        },
        loginByCode: (userId, code, cb) => {
            webApi
                .loginByCode(userId, code)
                .then(() => {
                    cb(true)
                    dispatch({ type: 'COMMON_RESET' })
                    dispatch({
                        type: 'COMMON_SET',
                        key: 'via',
                        value: 'iosapp'
                    })
                })
                .catch(err => {
                    console.warn('Admin.HomePage.loginByCode.ERROR', err)
                    cb(false)
                })
        },
        loadTeams: (divisionId) => {
            dispatch(act.loadTeamsByDivision(divisionId))
        },
        changeTeam: (teamId, data, divisionId) => {
            dispatch(act.updateTeam(teamId, data, divisionId))
        },
        loadMembers: (divisionId) => {
            dispatch(staff.loadStaffByDivision(divisionId))
        },
        loadTeamMembers: (teamId) => {
            dispatch(act.loadTeamUsersById(teamId))
        },
        deleteTeam: (divisionTeamId, teamId, divisionId) => {
            dispatch(act.deleteTeamFromDivision(divisionTeamId, divisionId))
        },
        changeRole: (member, teamId, divisionId) => {
            dispatch(act.updateTeamMember(divisionId, member))
        },
        resetTeamMember: (member, teamId, divisionId) => {
            dispatch(act.resetTeamMember(divisionId, member))
        }
    }
}

const TeamEditContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamEdit))

export default TeamEditContainer
